import axios from 'axios';
import { Feeder } from 'views/self-service/features/feeders/types/feeders.type';
import { CreateFeederInput } from 'views/self-service/features/feeders/types/create-feeder-input.type';

// POST Feeder
// /ewosapi/v1/shrimps/feeder/{globalCompanyId}
export const postFeeder = async (globalCompanyId: string, request: CreateFeederInput) => {
  const res = await axios.post<Feeder>(`/ewosapi/v1/shrimps/feeder/${globalCompanyId}`, request);
  return res.data;
};
